var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "page-container container" }, [
    _c("div", { staticClass: "page-content-wrapper" }, [
      _c(
        "div",
        { staticClass: "copyright-text" },
        [
          _c("h2", [_vm._v("Kontakt der CashPool-Banken")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n\t\t\t\tDiese Internetseite ist ein gemeinsamer Auftritt der CashPool-Partner Banken. Nachfolgend finden Sie\n\t\t\t\tden Kontakt der CashPool Banken:\n\t\t\t"
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.links, function(link, i) {
            return _c(
              "p",
              {
                key: i,
                on: {
                  click: function($event) {
                    return _vm.navigateTo(link.linkUrl)
                  }
                }
              },
              [
                _c("a", { attrs: { href: "#" } }, [
                  _vm._v(_vm._s(link.linkText))
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "copyright-text" }, [
      _c("p", [
        _vm._v(
          "\n\t\t\t\tDie CashPool-Partner unterliegen der Aufsicht durch die Bundesanstalt für\n\t\t\t\tFinanzdienstleistungsaufsicht.\n\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n\t\t\t\tRechtliche Hinweise / Haftungsausschluss:"),
        _c("br"),
        _vm._v(
          "\n\t\t\t\tDie CashPool-Partner prüfen und aktualisieren die Informationen auf den CashPool-Webseiten ständig.\n\t\t\t\tTrotz aller Sorgfalt können sich die Daten inzwischen verändert haben. Eine Haftung oder Garantie\n\t\t\t\tfür die Aktualität, Richtigkeit und Vollständigkeit der zur Verfügung gestellten Informationen kann\n\t\t\t\tdaher nicht übernommen werden. Gleiches gilt auch für alle anderen Internetseiten, auf die mit\n\t\t\t\tHyperlinks verwiesen wird. Die CashPool-Partner sind für den Inhalt der Internetseiten, die per\n\t\t\t\tHyperlinks erreicht werden, nicht verantwortlich.\n\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\t\tDarüber hinaus behalten sich die CashPool-Partner das Recht vor, Änderungen oder Ergänzungen der\n\t\t\t\tbereitgestellten Informationen vorzunehmen.\n\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\t\tInhalt und Struktur der CashPool-Internetseiten sind urheberrechtlich geschützt. Die\n\t\t\t\tVervielfältigung von Informationen oder Daten, insbesondere die Verwendung von Texten, Textteilen\n\t\t\t\toder Bildmaterial, bedarf der vorherigen Zustimmung der CashPool-Partner.\n\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("© CashPool-Partner. Alle Rechte vorbehalten.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }